import React, { useContext, useState } from "react";
import { UserContext } from "../../providers/UserProvider";
import {firestore} from "../../firebase";
import Paypal from "../../components/Paypal";
import {PricingTable, PricingSlot, PricingDetail} from 'react-pricing-table';
import "./style.css"

const PurchasePage = () => {
  const user = useContext(UserContext);
  const [userData, setUserData] = useState("");
  const userRef = firestore.collection('usersData').doc(user.uid);
  console.log("user is: ", user);
  console.log("emailverified? ",user.emailVerified);
  React.useEffect(()=>{
    userRef.get().then((doc) => {
        if (doc.exists) {
            let data = doc.data();
            setUserData(data);
        } else {
            // doc.data() will be undefined in this case
            setUserData(null);
            console.log("No such document!");
        }
    }).catch(function (error) {
        setUserData(null);
        console.log("Error getting document:", error);
    });
  },[])
  console.log("Document data: ", userData);
  if(!userData) return <div>Loading Data</div>

  return (
    <div>
      <h1 className="purchaseHeader">LawyerZ<br/>כאן תוכלו לרכוש החבילה המתאימה לכם על מנת להנות משירותי האתר</h1>
      <h1 style={{textAlign: "center", fontWeight: "700"}}>חבילות האתר</h1>
      <PricingTable  highlightColor='#1976D2'>
      {/* <Paypal /> */}
     <PricingSlot highlighted onClick={()=>console.log("here")} buttonText='לרכישה' title='Premium חבילת' priceText='209 ש"ח לחודש'>
        <PricingDetail>לפרסם העברות ולהגיש לידים</PricingDetail>
        <PricingDetail>5 :תחומי התמחות</PricingDetail>
        <PricingDetail>אזורי עבודה: 2</PricingDetail>
        <PricingDetail>גישה חופשית ללוחות האתר (התייעצויות ומודעות)</PricingDetail>
        <PricingDetail>פרסום מודעות ללא הגבלה</PricingDetail>
     </PricingSlot>
     <PricingSlot highlighted onClick={()=>console.log("here")} buttonText='לרכישה' title='Classic חבילת' priceText='179 ש"ח לחודש'>
        <PricingDetail>לפרסם העברות ולהגיש לידים</PricingDetail>
        <PricingDetail>3 :תחומי התמחות</PricingDetail>
        <PricingDetail>2 :אזורי עבודה</PricingDetail>
        <PricingDetail>גישה חופשית ללוחות האתר (התייעצויות ומודעות)</PricingDetail>
        <PricingDetail>פרסום מודעות באופן מוגבל</PricingDetail>
     </PricingSlot>
     <PricingSlot onClick={()=>console.log("here")} buttonText='לרכישה' title='Essential חבילת' priceText='ש"ח לחודש 129'>
        <PricingDetail>רק להגיש בידים על לידים</PricingDetail>
        <PricingDetail>2 :תחומי התמחות</PricingDetail>
        <PricingDetail> אזור עבודה אחד בארץ</PricingDetail>
        <PricingDetail>גישה חופשית ללוחות האתר (התייעצויות ומודעות)</PricingDetail>
        <PricingDetail strikethrough>אפשרות פרסום מודעות</PricingDetail>

     </PricingSlot>
     </PricingTable>
    </div>
  ) 
};

export default PurchasePage;

